import { Button, ButtonGroup, Grid } from "@material-ui/core"
import { memo } from "react"
import { useStyles } from "./historic-atualizacoes-filtro-styles"

export interface HistoricoAtualizacoesFiltroProps {
    setHistoricoFiltro: React.Dispatch<React.SetStateAction<"data" | "versao">>
    historicoFiltro: "data" | "versao"
}

export const HistoricoAtualizacoesFiltro = memo(({ historicoFiltro, setHistoricoFiltro }: HistoricoAtualizacoesFiltroProps) => {

    const classes = useStyles()

    return (
        <Grid className={classes.container}>
            <ButtonGroup color="default" variant="outlined">
                <Button
                    variant={historicoFiltro === "versao" ? "contained" : "outlined"}
                    color={historicoFiltro === "versao" ? "primary" : "default"}
                    onClick={() => setHistoricoFiltro("versao")}
                >
                    Por Versão
                </Button>
                <Button
                    variant={historicoFiltro === "data" ? "contained" : "outlined"}
                    color={historicoFiltro === "data" ? "primary" : "default"}
                    onClick={() => setHistoricoFiltro("data")}
                >
                    Por Data
                </Button>
            </ButtonGroup>
        </Grid>
    )
})

HistoricoAtualizacoesFiltro.displayName = 'BacklogFiltro'